import React from 'react';
import PropTypes from 'prop-types';
import TextDate from './TextDate';
import TextTime from './TextTime';


const TextDateTime = ({ value, className }) => {  
    return (
        <div><TextDate value={value} className={className}/>&nbsp;<TextTime value={value} className={className}/></div>
    );
  };
  
  TextDateTime.propTypes = {
    value: PropTypes.object,
    className: PropTypes.string
  };
  
  export default TextDateTime;